"use strict";
var tooltip_directive_1 = require("./tooltip-directive");
exports.NguiTooltipDirective = tooltip_directive_1.NguiTooltipDirective;
var tooltip_module_1 = require("./tooltip.module");
exports.NguiTooltipModule = tooltip_module_1.NguiTooltipModule;
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@ngui/tooltip/dist/index.js
// module id = 579
// module chunks = 4